export class NumberUtils {

  /**
   * Convertir un string > number
   *
   */
  public static parseNumber(value: string | null): number {

    if (!value) {
      return 0;
    }

    return Number.parseFloat(value.replace('.', ''));
  }


  /**
   * Comprobar si el valor del input está incompleto
   *
   */
  public static isInputIncomplete(value: number | string | null): boolean {

    if (value === null || value === undefined || value === '') {
      return true;
    }

    return /^-[.,]?$/.test(value.toString());
  }


  /**
   * Sustituir la coma por el punto
   *
   */
  public static replacePoint(value: number | string | null): number {

    if (!value && value !== 0) {
      return 0;
    }

    const parsed: number = Number.parseFloat(value.toString().replace(',', '.'));
    return Number.isNaN(parsed) ? 0 : parsed;
  }


  /**
   * Formatear número
   *
   */
  public static formatNumber(value: number | null, fractionDigits: number = 2): number {
    const num: number = typeof value === 'number' ? value : Number.parseFloat(String(value));

    if (Number.isNaN(num)) {
      return 0;
    }

    return Number.parseFloat(num.toFixed(fractionDigits));
  }

}
